import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dropdown"]

  connect() {
    this._onClickOutside = this._onClickOutside.bind(this)
    this._onKeydown = this._onKeydown.bind(this)
  }

  disconnect() {
    document.removeEventListener("click", this._onClickOutside)
    document.removeEventListener("keydown", this._onKeydown)
  }

  toggle() {
    if (this.dropdownTarget.classList.contains("notification-dropdown--open")) {
      this._close()
    } else {
      this._open()
    }
  }

  _open() {
    // Close any other open dropdowns
    document.querySelectorAll(".notification-dropdown--open").forEach(el => {
      el.classList.remove("notification-dropdown--open")
    })
    document.querySelectorAll(".show[data-user-menu-target='dropdown']").forEach(el => {
      el.classList.remove("show")
    })

    this.dropdownTarget.classList.add("notification-dropdown--open")
    requestAnimationFrame(() => {
      document.addEventListener("click", this._onClickOutside)
      document.addEventListener("keydown", this._onKeydown)
    })
  }

  _close() {
    this.dropdownTarget.classList.remove("notification-dropdown--open")
    document.removeEventListener("click", this._onClickOutside)
    document.removeEventListener("keydown", this._onKeydown)
  }

  _onClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this._close()
    }
  }

  _onKeydown(event) {
    if (event.key === "Escape") {
      this._close()
    }
  }
}
